import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
const Connected = ({ children }) => {
    const carousel = useCarouselContext();
    return children(carousel);
};
export default Connected;
